module.exports = __webpack_public_path__ + "static/media/44.554e88c7.png";